export default __webpack_public_path__ + "locales/fr/SalesDepartmentRequestDialog.json?hash=f4ae7cc379735b4c1f5321a38b484ba2";